import React, { Component } from 'react';
import './Empty.less';

export default class Empty extends Component {
    render(){
        return(
            <div className="empty-util">
                <div className="img"></div>
                <div className="text">{ this.props.text || '' }</div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/template/UtilTemplate/Empty.jsx